import { ActivatedRoute, Router } from '@angular/router';
import { Component, Input, OnChanges, OnInit, Output, SimpleChanges, EventEmitter, OnDestroy, ViewChild } from "@angular/core";
import { SharedService } from "../../../../services/shared.service";
import { Subscription } from "rxjs";
import { IRelatoriaCapituloModel } from 'src/app/models/relatoria-capitulo.model';
import { IModeloRelatoria } from '../osa-execucao-aba-papeis/osa-execucao-aba-papeis.component';
import Swal from 'sweetalert2';
import { IAuditorCoordenacaoModel } from 'src/app/models/auditor-coordenacao.model';
import { IOsaExecucaoEquipeAuditorModel, IOsaExecucaoEquipeModel, IOsaExecucaoModel, IOsaExecucaoUnidadeGestoraModel } from 'src/app/models/osa-execucao-model';
import { MatTableDataSource } from '@angular/material/table';
import { IOsaExecucaoSubtipoAuditoriaModel } from 'src/app/models/osa-execucao-subtipo-auditoria.model';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { BaseFormComponent } from 'src/app/shared/components/base-form/base-form.component';
import { ToastrService } from 'ngx-toastr';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { CoordenacaoService } from 'src/app/services/coordenacao.service';
import { DateHelper } from 'src/app/core/helpers/date.helper';
import { PaaService } from 'src/app/services/paa.service';
import { OsaExecucaoService } from 'src/app/services/osa-execucao.service';
import { OsaService } from 'src/app/services/osa.service';
import { IOsaModel } from 'src/app/models/osa-model';

@Component({
  selector: 'app-osa-execucao-abas',
  templateUrl: './osa-execucao-abas.component.html',
  styleUrls: ['./osa-execucao-abas.component.scss']
})
export class OsaExecucaoAbasComponent extends BaseFormComponent implements OnInit, OnChanges, OnDestroy {
  public aba = 0;
  @Input() public visualizar: boolean;
  @Input() public numeroOpa: any;
  @Input() public model: IOsaExecucaoModel;
  @Output() public abaEmitter: EventEmitter<number> = new EventEmitter<number>();
  @Input() public id: number;
  @Output() public handlerInit: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('TableOnePaginator', { static: true }) tableOnePaginator: MatPaginator;
  @ViewChild('tabela1', { static: true }) tabela1: MatSort;

  @ViewChild('TableTwoPaginator', { static: true }) tableTwoPaginator: MatPaginator;
  @ViewChild('tabela2', { static: true }) tabela2: MatSort;
  private validacaoSubscription: Subscription;
  public coordenadoresAuditoria = [] as IAuditorCoordenacaoModel[];
  public statusExecucao: number;
  public relatoriaDados: IRelatoriaCapituloModel[] = null;
  public modelRelatoria: IModeloRelatoria = {} as IModeloRelatoria;
  public hiddenEdicao: boolean = false;
  public enviandoParaAprovacao = false;
  public dadosObtidosOsaExecucao: IOsaExecucaoEquipeModel = {} as IOsaExecucaoEquipeModel;
  public subtipoDataSource = new MatTableDataSource<IOsaExecucaoSubtipoAuditoriaModel>([]);
  public auditoresDataSource = new MatTableDataSource<IOsaExecucaoEquipeAuditorModel>([]);
  public subtipoSemDados = true;
  public unidadeGestoraSemDados = true;
  public auditoresSemDados = true;
  public modelFilho: IOsaExecucaoModel;

  constructor(
    route: ActivatedRoute,
    toastr: ToastrService,
    localeService: BsLocaleService,
    public router: Router,
    private osaService: OsaService,
    public matDialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private sharedService: SharedService,
    private coordenacaoService: CoordenacaoService,
    private dateHelper: DateHelper,
    private paaService: PaaService,
    private osaExecusaoService: OsaExecucaoService
  ) {
    super(route, toastr, router, localeService, matDialog);
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  ngOnInit() {
    // Lógica original mantida
    const numeroAba = this.activatedRoute.snapshot.queryParamMap.get('aba');
    if (numeroAba) {
      this.mudarAba(Number(numeroAba));
    }

    this.router.url.includes("aba=6") ? this.mudarAba(6) : null;

    // Nova funcionalidade: Escuta solicitações de validação
    this.validacaoSubscription = this.sharedService.getValidacaoRequest().subscribe(() => {
      this.solicitarValidacaoAbaAtiva();
    });
  }

  ngOnDestroy(): void {
    if (this.validacaoSubscription) {
      this.validacaoSubscription.unsubscribe();
    }
  }

  public mudarAba(ind: number) {
    this.aba = ind;
    this.abaEmitter.emit(this.aba); // Corrigido: usar emit ao invés de next
  }

  /**
   * Solicita validação para a aba ativa
   */
  private solicitarValidacaoAbaAtiva() {

    //console.log(`Validando aba ${this.aba}`);

    switch (this.aba) {
      case 0:
        // Aba Informações Básicas - o AbaInformacoesBasicasComponent responderá automaticamente
        // pois está escutando o getValidacaoRequest() também
        //console.log('Validação da aba Informações Básicas será tratada pelo componente filho');
        break;

      case 1:
        // Aba de Documentos ou outra aba
        //this.validarAbaDocumentos();
        break;

      case 2:
        // Aba de Anexos
        //this.validarAbaAnexos();
        break;

      case 3:
        // Aba de Observações
        //this.validarAbaObservacoes();
        break;

      case 4:
        // Aba de Aprovação
        //this.validarAbaAprovacao();
        break;

      case 5:
        // Aba de Relatoria

        break;

      case 6:
        // Aba de Linha do Tempo
        break;

      case 7:
        // Aba de Relatoria
        break;

      case 8:
        // Aba de Auditoria
        //this.validarAbaAuditoria();
        break;

      default:
        // Para abas sem validação específica, responde sucesso
        //console.log(`Aba ${this.aba} não possui validações específicas`);
        //this.sharedService.sendValidacaoResponse(true);
        break;
    }
  }

  /**
   * Validações específicas para cada aba
   * Customize conforme as regras de negócio de cada aba
   */

  private validarAbaDocumentos() {
    // Exemplo de validação para aba de documentos
    // Implemente aqui as regras específicas desta aba
    console.log('Validando aba de documentos...');

    // Por enquanto, assumindo que passou na validação
    // Substitua por lógica real conforme necessário
    this.sharedService.sendValidacaoResponse(true);
  }

  private validarAbaAnexos() {
    console.log('Validando aba de anexos...');

    // Exemplo: verificar se anexos obrigatórios foram carregados
    // const anexosObrigatorios = this.verificarAnexosObrigatorios();
    // if (!anexosObrigatorios) {
    //   this.sharedService.sendValidacaoResponse(false, 'Anexos obrigatórios não foram carregados');
    //   return;
    // }

    this.sharedService.sendValidacaoResponse(true);
  }

  private validarAbaObservacoes() {
    console.log('Validando aba de observações...');

    // Exemplo: verificar se observações obrigatórias foram preenchidas
    // const observacoesValidas = this.verificarObservacoes();
    // if (!observacoesValidas) {
    //   this.sharedService.sendValidacaoResponse(false, 'Observações obrigatórias não foram preenchidas');
    //   return;
    // }

    this.sharedService.sendValidacaoResponse(true);
  }

  private validarAbaAuditoria() {
    console.log('Validando aba de auditoria...');

    // Implemente validações específicas para auditoria
    this.sharedService.sendValidacaoResponse(true);
  }

  private validarAbaRelatorio() {
    console.log('Validando aba de relatório...');

    // Exemplo: verificar se relatório foi gerado e está completo
    // const relatorioCompleto = this.verificarRelatorio();
    // if (!relatorioCompleto) {
    //   this.sharedService.sendValidacaoResponse(false, 'Relatório incompleto ou não gerado');
    //   return;
    // }

    this.sharedService.sendValidacaoResponse(true);
  }

  private validarAbaAprovacao() {
    console.log('Validando aba de aprovação...');

    // Exemplo: verificar se todas as etapas anteriores foram concluídas
    // const todasEtapasConcluidas = this.verificarEtapasAnteriores();
    // if (!todasEtapasConcluidas) {
    //   this.sharedService.sendValidacaoResponse(false, 'Conclua todas as etapas anteriores antes de aprovar');
    //   return;
    // }

    this.sharedService.sendValidacaoResponse(true);
  }

}

